<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardUpdateRecordList.push"
    :query-list="queryList"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-select-card-type-id="true"
    :is-show-select-card-update-type="true"
    card-update-type-select-label="操作分类"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-last-thirty-day="true"
  >
    <v-column-time value="修改时间"/>
    <el-table-column label="申请人" width="150" align="center">
      <template v-slot="{ row }">
        <v-avatar-nickname v-if="row.apply_administrator_id" :value="row.apply_administrator_avatar" :nickname="row.apply_administrator_nickname" :is-center="false"/>
        <span v-else-if="row.card_update_apply_id" class="success-color">学员本人</span>
        <span v-else class="hint-color">-</span>
      </template>
    </el-table-column>
    <el-table-column label="操作者" width="150" align="center">
      <template v-slot="{ row }">
        <v-avatar-nickname v-if="row.administrator_id" :value="row.administrator_avatar" :nickname="row.administrator_nickname" :is-center="false"/>
        <span v-else-if="row.operator_source === 1" class="success-color">学员本人</span>
        <span v-else-if="row.operator_source === 2" class="info-color">系统自动</span>
        <span v-else class="hint-color">后台系统</span>
      </template>
    </el-table-column>
    <el-table-column label="办卡门店" width="150" align="center" prop="store_name"/>
    <el-table-column label="操作分类" width="150" align="center">
      <template v-slot="{ row }">
        <template v-for="updateType in updateTypes">
          <template v-if="updateType.value === row.update_type">{{ updateType.name }}</template>
        </template>
      </template>
    </el-table-column>
    <v-column-student label="所属学员" link-page-id="old_student_id"/>
    <el-table-column label="课卡类型" prop="card_type_name" width="140px"/>
    <el-table-column label="课卡名称" align="center">
      <template v-slot="{ row }">
        <div class="flex-justify-center">
          <el-tag type="info">{{ row.old_card_name }}</el-tag>

          <div v-if="row.old_card_name !== row.card_name">
            <i class="icon-arrow-right" />

            <el-tag>{{ row.card_name }}</el-tag>
          </div>
        </div>
      </template>
    </el-table-column>
    <template v-if="is2k">
      <el-table-column label="剩余次数" width="150" align="center">
        <template v-slot="{ row }">
          <div class="flex-justify-center">
            <el-tag type="info" v-if="row.old_is_number_limit">{{ row.old_expire_number | toYuan }}</el-tag>

            <el-tag type="info" v-else>-</el-tag>

            <div v-if="row.old_expire_number !== row.expire_number">
              <v-icon name="arrow-right"/>

              <el-tag v-if="row.is_number_limit">{{ row.expire_number | toYuan }}</el-tag>

              <el-tag v-else>-</el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="失效日期" width="300" align="center">
        <template v-slot="{ row }">
          <div class="flex-justify-center">
            <el-tag type="info">{{ row.old_expire_time | timeToYmd('-') }}</el-tag>

            <div v-if="row.old_expire_time !== row.expire_time">
              <v-icon name="arrow-right"/>

              <el-tag>{{ row.expire_time | timeToYmd('-') }}</el-tag>
            </div>
          </div>
        </template>
      </el-table-column>
    </template>


    <el-table-column label="修改所补差价" width="150" align="center">
      <template v-slot="{ row }">{{ row.update_payment | toYuan }}</template>
    </el-table-column>

    <el-table-column
      label="操作"
      align="center"
      width="150"
      class-name="small-padding fixed-width"
    >
      <template v-slot="{ row }">
        <v-list-button icon="browse" name="查看详情" size="large" :to="RouteConfig.cardUpdateRecordDetail.to(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-update-record-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.old_student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>课卡 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>课卡名称</span>
              <span>{{ v.card_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课卡类型</span>
              <span>{{ v.card_type_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>失效日期</span>
              <span>{{ v.expire_time | timeToYmd }}</span>
            </div>
            <div class="list-item-detail">
              <span>办卡门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>剩余次数</span>
              <span>{{ v.expire_number | toYuan }} 次</span>
            </div>
            <div class="list-item-detail">
              <span>实际收款</span>
              <span>{{ v.actual_payment | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>收款方式</span>
              <span>{{ findPaymentModeName(v.card_payment_mode_id) }}</span>
            </div>

            <div class="list-item-detail">
              <span>状态</span>
              <span v-if="v.is_reviewing" class="warning-color">审核中</span>
              <span v-else-if="v.is_locked" class="warning-color">锁定中</span>
              <span v-else-if="v.is_stopped" class="danger-color">停卡中</span>
              <template v-else>
                <span v-if="!v.expire_time" class="primary-color">未开卡</span>
                <span v-else-if="v.is_number_limit && !v.expire_number" class="info-color">已用完</span>
                <span v-else-if="v.is_expired" class="info-color">已过期</span>
                <span v-else class="success-color">可使用</span>
              </template>
            </div>
            <div class="list-item-button">
              <v-list-button
                icon="browse"
                name="查看详情"
                size="large"
                :to="RouteConfig.cardUpdateRecordDetail.to(v.id)"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>

  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import updateTypes from '@/enums/cardUpdateTypes';
import { mapGetters } from 'vuex';
import { index, destroy } from '@/api/card-update-record';
import { getLegalQueryList } from "@/utils/formats";
import { checkYmdIsBetweenSetUpAndToday } from "@/utils/validate";
import { findPaymentModeName } from "@/enums/paymentModes";

export default {
  name: RouteConfig.cardUpdateRecordList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    timeLimit: [],
    queryList: {
      keyword: '',
      store_id: '',
      card_type_id: 0,
      update_types: [],
      limit: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    isLoading: false,
    isDeleting: false,
    updateTypes,
  }),
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'defaultStoreId',
      'is2k',
    ]),
  },
  watch: {
    '$route'(to) {
      this.load(to);
    },
    queryList(queryList) {
      this.timeLimit = [queryList.start_date, queryList.end_date];
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findPaymentModeName,
    refresh() {
      RouteConfig.cardUpdateRecordList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        queryList.start_date = '';
        queryList.end_date = '';
      }

      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleDelete(id) {
      if (this.isDeleting) return;

      this.isDeleting = true;
      const { isError } = await destroy(id);
      this.isDeleting = false;
      if (isError) return;

      this.load();
    },
  },
};
</script>

<style scoped>
  .icon-arrow-right {
    margin: 0 6px;
    font-size: 16px;
  }
</style>
